<app-base-inboxes
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [pageTitle]="pageTitle"
  [pageId]="pageId"
  [pageTagName]="tagName"
>
</app-base-inboxes>
